module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/activate-socialads.e1c687d3.svg";